import { useAppSelector } from '@/shared/lib/redux/hooks';
import { useListMembershipsQuery } from '../api/authApi';

/** The signed-in user's own membership row for `store.currentStoreId` — role/status for the
 *  admin panel's permission checks (CLAUDE.md: MANAGER is view-only on catalog/prices). */
export function useCurrentMembership() {
  const currentStoreId = useAppSelector((state) => state.store.currentStoreId);
  const { data: memberships } = useListMembershipsQuery();
  return memberships?.find((m) => m.storeId === currentStoreId);
}

/** `true` for OWNER/ADMIN — the roles allowed to mutate catalog/pricing data. MANAGER (and any
 *  role below it) is read-only there. */
export function useCanManageCatalog(): boolean {
  const role = useCurrentMembership()?.role;
  return role === 'OWNER' || role === 'ADMIN';
}

/** `true` for OWNER/ADMIN — same role set as `useCanManageCatalog`, named for its other call
 *  sites (cancelling a COMPLETED order, reverting SHIPPED, viewing the audit log). */
export function useIsOwnerOrAdmin(): boolean {
  const role = useCurrentMembership()?.role;
  return role === 'OWNER' || role === 'ADMIN';
}
